import { render, staticRenderFns } from "./OPGeneralDetailComponent.vue?vue&type=template&id=c2721a88&"
import script from "./OPGeneralDetailComponent.vue?vue&type=script&lang=js&"
export * from "./OPGeneralDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports